// src/components/Configuration/SettingCard.jsx
import React, { useMemo } from 'react';

export default function SettingCard({
  DesignSystemComponents,
  title,
  subtitle,
  editMode = false,
  Card,
  Select,
  Dropdown,
  selectOptions,
  selectValue,
  onSelectChange,
  placeholder,
  iconName,
  renderEdit,
  children,
  SvgIcon, // can be passed directly OR via DesignSystemComponents
}) {
  // pull fallbacks from DesignSystemComponents if not provided directly
  const DSvgIcon = SvgIcon || DesignSystemComponents?.SvgIcon;
  const DCard = Card || DesignSystemComponents?.Card;
  const Wrapper = DCard || 'div';

  const selectedOption = useMemo(() => {
    if (!Dropdown || !selectOptions) return null;
    return selectOptions.find((o) => o.value === selectValue) ?? null;
  }, [Dropdown, selectOptions, selectValue]);

  const SelectControl = ({ value, onChange, options, placeholder }) => {
    if (Dropdown) {
      return (
        <Dropdown
          options={options}
          value={selectedOption}
          onChange={(opt) => onChange?.(opt?.value)}
          placeholder={placeholder}
          width='100%'
          menuPortalTarget={document.body}
          menuPosition='fixed'
        />
      );
    }

    if (Select) {
      return (
        <Select
          value={value}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
        />
      );
    }

    return (
      <select
        className='form-select'
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {options?.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    );
  };

  return (
    <Wrapper className={DCard ? undefined : 'p-3 border rounded-3'}>
      <div className='d-flex flex-column'>
        <div className='d-flex gap-2 align-items-center mb-2'>
          {' '}
          {DSvgIcon && iconName ? (
            <DSvgIcon name={iconName} size='24px' stroke='var(--primary-500)' />
          ) : null}
          <h3 className='caption fw-bold'>{title}</h3>
        </div>

        {subtitle ? (
          <p className='mini color-gray-600 mb-2'>{subtitle}</p>
        ) : null}

        {editMode ? (
          renderEdit ? (
            renderEdit({
              Select,
              Dropdown,
              selectOptions,
              selectValue,
              onSelectChange,
              placeholder,
            })
          ) : selectOptions ? (
            <SelectControl
              value={selectValue}
              onChange={onSelectChange}
              options={selectOptions}
              placeholder={placeholder}
            />
          ) : null
        ) : (
          children
        )}
      </div>
    </Wrapper>
  );
}
